import 'script-loader!jquery';
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js';
import 'script-loader!slick-carousel';
import 'script-loader!smartmenus';
import 'hamburgers/dist/hamburgers.css';
import AOS from 'aos';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@fortawesome/fontawesome-free/js/all.js';
import '@fortawesome/fontawesome-free/css/all.css';
import 'smartmenus/dist/css/sm-core-css.css';
import 'smartmenus/dist/css/sm-simple/sm-simple.scss';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import '../scss/entry.scss';

jQuery(document).ready(function($) {
	
	// tab content block
	$('.ffw-tabber').on('click', function() {
		$(this).siblings().removeClass('active');
	});
	
	// desktop header search toggle
	$('li.dt-search a').on('click', function() {
		$(this).children().toggleClass('fa-search fa-times');
		$('.dt-search-wrap').toggleClass('open closed');
		$('.utility-menu > .menu-item').each(function(i) {
			$(this).toggleClass('menu-item-hidden');
		})
	});

	// bootstrap popovers -- see: https://getbootstrap.com/docs/5.0/components/popovers/
	if ($('[data-bs-toggle="popover"]')[0]) {
		var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
		popoverTriggerList.map(function(popoverTriggerEl) {
			return new bootstrap.Popover(popoverTriggerEl);
		});
		new bootstrap.Popover(document.querySelector('.popover-dismiss'), { trigger: 'focus' });
	}

	// bootstrap tooltips -- see: https://getbootstrap.com/docs/5.0/components/tooltips/
	if ($('[data-bs-toggle="tooltip"]')[0]) {
		var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		tooltipTriggerList.map(function(tooltipTriggerEl) {
			return new bootstrap.Tooltip(tooltipTriggerEl);
		});
	}

	// hamburger stuffs
	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
			}, false);
		});
	}

	// acf accordions
	$('.acf-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.icon').children('.plus-minus').toggleClass('plusser minus');
	});

	// accordions
	$('.accordion-toggle').on('click', function() {
		$(this).next('.accordion-toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
		$(this).toggleClass('active');
	});

	// simple accordions
	$('.simple-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
	});

	// header search toggle
	$('#search-toggle').on('click', function() {
		$(this).toggleClass('glass').toggleClass('close');
		$('#search-box').toggleClass('open');
		$('#top-search').focus();
	});

	// add responsive class to all images
	$(function() {
		$('img').addClass('img-fluid');
	});

	// primary menu
	$(function() {
		$('.sm').smartmenus({
			subMenusSubOffsetX: 0,
			subMenusSubOffsetY: -1
		});
	});

	// primary navigation toggle
	$('.nav-toggle').on('click', function() {
		$('.primary-nav-wrap').slideToggle('fast');
	});

	// scroll back to top button
	$(document).ready(function($){
		// browser window scroll (in pixels) after which the "back to top" link is shown
		var offset = 300,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offset_opacity = 1200,
			//duration of the top scrolling animation (in ms)
			scroll_top_duration = 300,
			//grab the "back to top" link
			$back_to_top = $('.cd-top');
		//hide or show the "back to top" link
		$(window).scroll(function(){
			( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > offset_opacity ) { 
				$back_to_top.addClass('cd-fade-out');
			}
		});
		//smooth scroll to top
		$back_to_top.on('click', function(event){
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
				}, scroll_top_duration
			);
		});
	});

	// FAQ accordion -- one open at a time, driven by aria-expanded
	$(document).on('click', '.acf-faq-wrap .faq-question', function() {
		var $btn = $(this);
		var $panel = $('#' + $btn.attr('aria-controls'));
		var open = $btn.attr('aria-expanded') === 'true';
		var $list = $btn.closest('.faq-list');
		$list.find('.faq-question[aria-expanded="true"]').not($btn).each(function() {
			$(this).attr('aria-expanded', 'false');
			$('#' + $(this).attr('aria-controls')).slideUp('fast', function() { this.hidden = true; });
		});
		if (open) {
			$btn.attr('aria-expanded', 'false');
			$panel.slideUp('fast', function() { this.hidden = true; });
		} else {
			$btn.attr('aria-expanded', 'true');
			$panel.prop('hidden', false).hide().slideDown('fast');
		}
	});

	// ---------------------------------------------------------------- carousels
	// ------------------------------------------------------------------ marquee
	// A strip that drifts at a constant speed and loops seamlessly.
	//
	// Slick cannot do this. Its documented marquee trick (autoplaySpeed 0 plus a
	// long linear speed) leaves slick's own `animating` flag stuck true after the
	// first tick and the track stops dead, with nothing in the console. So a
	// marquee here opts out of slick entirely and runs a rAF loop.
	//
	// $track  the strip; its children are the items
	// opts    speed in px/sec, easing for nudges, element that pauses on hover
	// returns { nudge: fn(px), measure: fn } -- nudge lets arrows push the strip
	//         along without fighting the drift
	function initMarquee($track, opts) {
		var o = $.extend({
			speed:   40,
			easing:  8,
			pauseOn: null
		}, opts || {});

		var $items = $track.children();
		if (!$items.length) {
			return null;
		}

		// The clipping happens on a viewport inside the block's wrap, not on the
		// wrap itself: arrows straddle the wrap's edges and would be sliced in half.
		$track.wrap('<div class="marquee-viewport"></div>');
		$track.addClass('marquee-track is-marquee');

		var $viewport = $track.parent();

		// AOS and the marquee both write `transform`, and AOS also puts a 0.7s
		// transition on the element it owns. With both on the same node every frame
		// the marquee sets becomes a 0.7s interpolation toward a target that has
		// already moved on, so the strip creeps instead of scrolling and never sheds
		// the fade-up's 100px Y offset. Hand the AOS attributes to the viewport: the
		// reveal still happens, on an element whose transform nothing else touches.
		var aosAttrs = {};
		$.each($track[0].attributes, function(_, attr) {
			if (attr.name.indexOf('data-aos') === 0) {
				aosAttrs[attr.name] = attr.value;
			}
		});
		$.each(aosAttrs, function(name, value) {
			$viewport.attr(name, value);
			$track.removeAttr(name);
		});
		$track.removeClass('aos-init aos-animate');

		// Clone whole sets until the strip is at least a viewport plus one set
		// wide. One clone is enough for a long strip; a short one (three logos,
		// say) needs several or the reset leaves visible empty track.
		var baseWidth = $track[0].scrollWidth;
		var needed    = $viewport.outerWidth() + baseWidth;
		var guard     = 0;
		do {
			$track.append($items.clone(true).attr('aria-hidden', 'true'));
			guard++;
		} while ($track[0].scrollWidth < needed && guard < 12);

		var offset   = 0;
		var pending  = 0;
		var paused   = false;
		var setWidth = 0;
		var step     = 0;
		var last     = null;

		// Measured off offsetLeft rather than summed widths, so whatever flex gap
		// the breakpoint sets is included without having to parse it.
		function measure() {
			var $all = $track.children();
			if ($all.length <= $items.length) {
				setWidth = 0;
				return;
			}
			setWidth = $all.eq($items.length)[0].offsetLeft - $all.eq(0)[0].offsetLeft;
			step = $all.length > 1
				? $all.eq(1)[0].offsetLeft - $all.eq(0)[0].offsetLeft
				: setWidth;
		}

		function frame(ts) {
			if (last === null) {
				last = ts;
			}
			// a backgrounded tab hands back one enormous delta on return
			var dt = Math.min(ts - last, 100);
			last = ts;

			if (setWidth > 0) {
				if (!paused) {
					offset -= o.speed * dt / 1000;
				}
				if (pending !== 0) {
					var move = Math.abs(pending) < 0.5
						? pending
						: pending * Math.min(1, o.easing * dt / 1000);
					offset  += move;
					pending -= move;
				}
				while (offset <= -setWidth) { offset += setWidth; }
				while (offset > 0)          { offset -= setWidth; }
				$track.css('transform', 'translate3d(' + offset.toFixed(2) + 'px, 0, 0)');
			}
			window.requestAnimationFrame(frame);
		}

		measure();
		$(window).on('resize load', measure);
		window.requestAnimationFrame(frame);

		// Native mouseenter/mouseleave, deliberately not jQuery's. jQuery
		// synthesises those from mouseover/mouseout plus relatedTarget, and a
		// strip whose children slide under a stationary cursor churns out pairs
		// where relatedTarget is null. jQuery reads one of those as an enter even
		// though the cursor has already left, and the marquee stays parked with no
		// leave ever coming. The native events are geometry-based and immune.
		var pauseEl = (o.pauseOn || $viewport)[0];
		if (pauseEl) {
			pauseEl.addEventListener('mouseenter', function() { paused = true; });
			pauseEl.addEventListener('mouseleave', function() { paused = false; });
		}

		var api = {
			measure:  measure,
			step:     function() { return step; },
			nudge:    function(px) { pending += px; },
			// exposed so the strip can be inspected from the console, which is the
			// only way to tell a paused marquee from a stalled one
			state:    function() {
				return { paused: paused, offset: offset, setWidth: setWidth, step: step, speed: o.speed };
			},
			pause:    function() { paused = true; },
			play:     function() { paused = false; }
		};
		$track.data('marquee', api);
		return api;
	}

	// CTA Carousel -- a drifting strip of image cards, arrows on the strip edges
	$('.cta-carousel-slider').each(function() {
		var $track = $(this);
		var $wrap  = $track.closest('.cta-carousel-slider-wrap');
		var m = initMarquee($track, { speed: 40, pauseOn: $wrap });

		if (!m) {
			return;
		}

		// The arrows shift the strip one card and hand it straight back to the drift
		$wrap.find('.slider-next').on('click', function() { m.nudge(-m.step()); });
		$wrap.find('.slider-prev').on('click', function() { m.nudge(m.step()); });
	});

	// Insights -- fixed 552px cards that deliberately run past the container
	$('.insights-slider').each(function() {
		var $slider = $(this);
		var $arrows = $slider.siblings('.insights-arrows');
		$slider.slick({
			// rows:0 stops slick rebuilding the DOM. Its default (rows:1) wraps
			// every child in two generated divs, so .slick-slide would be a
			// slick-made element and our slide markup would sit two levels
			// under it -- which breaks equal-height stretching.
			rows: 0,
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: true,
			prevArrow: $arrows.find('.slider-prev'),
			nextArrow: $arrows.find('.slider-next'),
			responsive: [
				{ breakpoint: 768, settings: { slidesToShow: 1 } }
			]
		});
	});

	// Logos -- press logos on a slow continuous crawl. Slick's autoplay stepped
	// one logo every 2.5s, which reads as a twitch rather than a scroll, so this
	// uses the same marquee as the CTA carousel at a gentler speed.
	$('.logos-slider').each(function() {
		initMarquee($(this), { speed: 45 });
	});

	// (Removed) a generic .slider-prev/.slider-next handler used to live here. It
	// resolved the slider as $(this).parent().prev(), which is the heading div in
	// every block that uses these buttons, so it threw on click and double-bound
	// the arrows slick already owns. Each slider passes its own prevArrow and
	// nextArrow, so nothing generic is needed.

	// header scroll effects
	(function () {
		var previousScroll = 0;
		$(window).scroll(function(){
			var scrollTop = $(window).scrollTop();
			var currentScroll = $(this).scrollTop();
			if (currentScroll > previousScroll) {
				$('#masthead').addClass('scrolling-down');
				$('#masthead').removeClass('scrolling-up');
			} else {
				$('#masthead').addClass('scrolling-up');
				
				$('#masthead').removeClass('scrolling-down');
			}
			if (scrollTop == 0) {
				$('#masthead').removeClass('scrolling-up');
			}
			previousScroll = currentScroll;
		});
	}());

	// fancybox
	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});

	// animate on scroll init
	const throttle = (func, delay) => {
		let prev = 0;
		return (...args) => {
			let now = new Date().getTime();

			if (now - prev > delay) {
				prev = now;
				return func(...args);
			}
		}
	}
	AOS.init({ once: true, duration: 700 });
	$(window).on("scroll", throttle( function() { AOS.refresh() }, 500));
});